<div>
	<div class="center-page blue-pattern-bg">
		<div *ngIf="!loading" class="flex-login">
			<div class="login-holder card">
				<ng-container *ngIf="!showSuccess">
					<h2>Change Password</h2>
					<div>
						<form (ngSubmit)="next()" [formGroup]="form" autocomplete="off"
							  class="m-t-30 animate__animated animate__fadeIn">
							<app-kamona-password-input
								(emitInput)="setPassword($event)"
								[input]="passwordInput">
							</app-kamona-password-input>

							<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-30" nz-row>
								<div [nzSpan]="12" class="gutter-row cta-secondary-link" nz-col>
									<a [routerLink]="'/login'">Go back to Login</a>
								</div>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<app-kamona-custom-button
										[isBlock]="true" [isSubmitting]="submittingForm" text="Next">
									</app-kamona-custom-button>
								</div>
							</div>
						</form>
					</div>
				</ng-container>
				<ng-container *ngIf="showSuccess">
					<h2>Password change was successful </h2>
					<p>
						Return to the login page to continue
					</p>
					<div class="m-t-30">
						<app-kamona-custom-button
							[isBlock]="true" [isSubmitting]="submittingForm"
							[routerLink]="'/login'"
							text="Next">
						</app-kamona-custom-button>
					</div>
				</ng-container>
			</div>
		</div>
		<div *ngIf="loading">
			<app-kamona-loading></app-kamona-loading>
		</div>
	</div>
</div>
